import { render, staticRenderFns } from "./AddNewPayment.vue?vue&type=template&id=1400c3d9&"
import script from "./AddNewPayment.vue?vue&type=script&lang=js&"
export * from "./AddNewPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports